import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useWishlist } from "../context/WishlistContext";
import { Trash2, ArrowRight } from "lucide-react";

export default function Wishlist() {
    const { t } = useTranslation();
    const { items, remove } = useWishlist();

    return (
        <div data-testid="wishlist-page" className="pt-28 min-h-[80vh]">
            <section className="container-rail pb-12 border-b border-white/5">
                <div className="text-overline text-[#A3A3A3] mb-4">{t("wishlist.page_label")}</div>
                <h1 className="text-display text-5xl sm:text-6xl md:text-7xl leading-[0.92]">
                    {t("wishlist.page_title_1")} <span className="text-display-italic">{t("wishlist.page_title_italic")}</span>.
                </h1>
                <p className="text-[#A3A3A3] mt-4 max-w-md">
                    {t("wishlist.page_subtitle")}
                </p>
            </section>

            <section className="container-rail py-14">
                {items.length === 0 ? (
                    <div className="py-24 text-center space-y-5">
                        <div className="text-overline text-[#666]">{t("wishlist.empty_label")}</div>
                        <p className="text-[#A3A3A3]">{t("wishlist.empty_body")}</p>
                        <Link to="/shop" className="btn-primary inline-flex mt-2" data-testid="wishlist-shop-link">
                            {t("wishlist.browse_catalogue")} <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {items.map((item) => (
                            <div key={item.id} data-testid={`wishlist-item-${item.slug}`} className="group border border-white/[0.06] bg-[#101010] hover:border-white/20 transition-colors">
                                <Link to={`/product/${item.slug}`} className="block relative aspect-[3/4] overflow-hidden">
                                    <img src={item.image} alt={item.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                                </Link>
                                <div className="p-5 flex items-start justify-between gap-4">
                                    <div>
                                        <div className="text-overline text-[#666] mb-1">{item.category}</div>
                                        <Link to={`/product/${item.slug}`} className="text-display text-xl">
                                            {item.name}
                                        </Link>
                                        <div className="text-brutal text-sm mt-1.5">${item.price}</div>
                                    </div>
                                    <button
                                        onClick={() => remove(item.id)}
                                        data-testid={`wishlist-remove-${item.slug}`}
                                        aria-label={t("wishlist.remove")}
                                        className="p-2 text-[#666] hover:text-[#F4F4F0] hover:bg-white/[0.04] transition-colors"
                                    >
                                        <Trash2 className="h-4 w-4" strokeWidth={1.3} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
